import * as React from "react";
import i18n from "../../../i18n/i18n";
import { CertificateType } from "../../../models/flags/CertificateType";
import { CertificateProcessType } from "../../../models/flags/CertificateProcessType";
import { PaymentType } from "../../../models/enums/PaymentType";
import { InvoiceStatusType } from "../../../models/enums/InvoiceStatusType";

interface IApplicationInfoComponentProps {
  certificateNumber: string;
  certificateType: CertificateType;
  certificateProcessType: CertificateProcessType;
  invoiceNumber: number;
  invoiceAmount: string;
  invoicePaymentType: PaymentType;
  invoiceStatus: InvoiceStatusType;
}

export default class ApplicationInfoComponent extends React.Component<IApplicationInfoComponentProps> {
  public render(): JSX.Element {
    const { certificateNumber, certificateType, certificateProcessType, invoiceNumber, invoiceAmount, invoicePaymentType, invoiceStatus } = this.props;

    return (
      <table>
        <tbody>
          <tr>
            <td>{i18n.t("TEXT_APPLICATION_NUMBER")}: </td>
            <td data-ui-test="invoice-certificateNumber" style={{ wordBreak: "break-word" }}>
              <b>{certificateNumber}</b>
            </td>
          </tr>
          <tr>
            <td>{i18n.t("TEXT_LICENSE_TYPE")}: </td>
            <td data-ui-test="invoice-certificateType" style={{ wordBreak: "break-word" }}>
              <b>
                {CertificateType.displayName(certificateType)} ({CertificateProcessType.displayName(certificateProcessType)})
              </b>
            </td>
          </tr>
          <tr>
            <td>{i18n.t("TEXT_INVOICE_NUMBER")}: </td>
            <td data-ui-test="invoice-invoiceNumber" style={{ wordBreak: "break-word" }}>
              <b>{invoiceNumber}</b>
            </td>
          </tr>
          <tr>
            <td>{i18n.t("TEXT_INVOICE_PRICE")}: </td>
            <td data-ui-test="invoice-invoiceAmount" style={{ wordBreak: "break-word" }}>
              <b>{invoiceAmount} DKK</b>
            </td>
          </tr>
          <tr>
            <td>{i18n.t("TEXT_INVOICE_PAYMENT_TYPE")}: </td>
            <td data-ui-test="invoice-invoicePaymentType" style={{ wordBreak: "break-word" }}>
              <b>{PaymentType.displayName(invoicePaymentType)}</b>
            </td>
          </tr>
          <tr>
            <td>{i18n.t("TEXT_INVOICE_TRANSACTION_STATUS")}: </td>
            <td data-ui-test="invoice-invoiceStatus" style={{ wordBreak: "break-word" }}>
              <b>{InvoiceStatusType.displayName(invoiceStatus)}</b>
            </td>
          </tr>
        </tbody>
      </table>
    );
  }
}
